const Error = () => {
  return <div>An error happened</div>;
};

export { Error };
